import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';
import { EventType } from '@/types/projects.types';

const setActivePreviewPageTabReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | EventType | null>) => {
    state.activePreviewPageTab = action.payload;
  });
};

export default setActivePreviewPageTabReducer;
